import {Component, HostListener, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BaseComponent, WmsTypeaheadComponent} from "@wms/components";
import {FormsModule} from "@angular/forms";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {filter, get, isEqual, isNil, orderBy} from "lodash-es";
import {NotificationService} from "@wms/services";
import {PrefabPublishService} from "@wms/prefab-publish";
import { isNewVerGreaterThanCurrentVer } from '@wms/app/core/utils/utils';
const semver = require("semver");
@Component({
  selector: 'wms-ptt-information',
  standalone: true,
  imports: [CommonModule, FormsModule, TooltipModule, WmsTypeaheadComponent],
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.less']
})
export class InformationComponent extends BaseComponent implements OnInit {

  @Input() artifactPublishDetails: any;
  @Input() artifactDetails: any;
  @Input() dependencies: any[];
  @Input() categories: any[];
  @Input() processing: boolean;
  @Input() draftAlert: boolean;
  @Input() isNewArtifact: boolean;

  showCategoriesList: boolean;
  showErrMsg: boolean;
  showInfoMsg: boolean;
  errMsg: string;
  infoMsg: string;
  validatingVersion: boolean;
  tooltipVisible: boolean = false;

  constructor(private notificationService: NotificationService, private prefabPublishService: PrefabPublishService) {
    super();
  }

  @HostListener('document:keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.showCategoriesList) {
      this.showCategoriesList = false;
    }
  }

  ngOnInit() {
    this.showErrMsg = false;
    this.showInfoMsg = this.artifactPublishDetails.isDraft;
    this.infoMsg =  this.showInfoMsg ? this.locale.LABEL_PUBLISH_ARTIFACT_AS_DRAFT_ALERT : "";
  }

  getCategories() {
    if(this.artifactPublishDetails.query){
      return orderBy(filter(this.categories, (category: any) => {
        return category.includes(this.artifactPublishDetails.query.toLowerCase());
      }),'name',['desc']);
    } else {
      return orderBy(this.categories, ['name'], ['desc']);
    }
  }

  changeArtifactCategory(category: any) {
    this.artifactPublishDetails.query = this.artifactPublishDetails.category = category;
    this.showCategoriesList           = false;
  };

  addNewArtifactCategory() {
    let data          = { "name": this.artifactPublishDetails.newCategory },
        categoryList  = this.categories.map((category: any) => {
                          return category.toLowerCase()
                        }) || [];
    if (this.artifactPublishDetails.newCategory.length && categoryList.indexOf(this.artifactPublishDetails.newCategory.toLowerCase()) == -1) {
      this.processing = true;
      this.projectService.setCategory(data).then((response: any) => {
        this.prefabPublishService.getArtifactCategories(this.categories, this.processing, this.artifactPublishDetails).then(() => {
          this.artifactPublishDetails.query       =  this.artifactPublishDetails.newCategory;
          this.artifactPublishDetails.category    = this.artifactPublishDetails.newCategory;
          this.artifactPublishDetails.categories  = this.categories;
          this.showCategoriesList                 = false;
          this.artifactPublishDetails.newCategory = "";
          this.processing                         = false;
        });
      }, (error: any) => {
        this.processing = false;
        this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, error);
      });
    } else {
      // category already exists
      this.notificationService.show('info', this.locale.MESSAGE_INFO_TITLE, this.locale.LABEL_ARTIFACT_CATEGORY_EXISTS.replace("${0}", this.artifactPublishDetails.newCategory));
      this.artifactPublishDetails.newCategory = "";
    }
  };
  CheckIfVersionAvailableToPublish () {
    // validate versions api
    this.validatingVersion = true;
    let urlParams: any =  {
      artifactId  : this.artifactDetails.artifactVO.artifactId,
      version     : this.artifactPublishDetails.newVersion
    }
    this.projectService.versionAvailableToPublish(urlParams).then((available: any) => {
      this.validatingVersion = false;
      if(available) { // if new version was not published earlier
        this.showErrMsg             = false;
        this.artifactPublishDetails.isValid = true;
      } else { // show error msg if new version was already published
        this.artifactPublishDetails.isValid = false;
        this.showErrMsg = true;
        this.errMsg     =  this.locale.MSG_VERSION_ALREADY_PUBLISHED;
      }
    }, (error: any) => {
      this.validatingVersion = false;
      this.artifactPublishDetails.isValid = false;
      this.showErrMsg = true;
      this.errMsg     =  this.locale.MESSAGE_ERROR_TITLE;
    });
  }
  validateVersion(newVersion: string) {
    this.artifactPublishDetails.newVersion = newVersion;
    //default valid state
    this.showErrMsg                     = false;
    this.artifactPublishDetails.isValid = true;
    let isDraft = get(this.artifactDetails, 'artifactVO.status', 'PUBLISHED') === "DRAFT";
    // Show error if new version is not valid
    if(this.artifactPublishDetails.newVersion.length > 40) {
      this.artifactPublishDetails.isValid = false;
      this.showErrMsg                     = true;
      this.errMsg                         = this.locale.MSG_PUBLISH_PREFAB_VERSION_CONFLICT_3;
    } else if (semver.valid(this.artifactPublishDetails.newVersion) === null || this.artifactPublishDetails.newVersion === '0.0.0') {
      this.artifactPublishDetails.isValid = false;
      this.showErrMsg                     = true;
      this.errMsg                         = this.locale.MSG_PUBLISH_PREFAB_VERSION_CONFLICT_2;
    } else if (!isDraft && isEqual(this.artifactPublishDetails.newVersion, this.artifactPublishDetails.currentVersion)) { // if current and new version are same
      // check if current version and latest version are same
      this.artifactPublishDetails.isValid = false;
      this.showErrMsg                     = true;
      this.errMsg                         = this.locale.MSG_PUBLISH_PREFAB_VERSION_CONFLICT_1;
    } else if (!this.isNewArtifact && this.artifactDetails.artifactVO.branch !== this.projectService.projectEdnDetails.vcsBranch) {
      return;
    } else if(semver.compare(this.artifactPublishDetails.newVersion, this.artifactPublishDetails.currentVersion) === 0) { // compare() returns 0 if both the versions match except build metadata
      this.artifactPublishDetails.isValid = false;
      this.showErrMsg                     = true;
      this.errMsg                         =  this.locale.MSG_PUBLISH_PREFAB_VERSION_CONFLICT_4.replace('${0}', this.artifactPublishDetails.newVersion).replace('${1}', this.artifactPublishDetails.currentVersion);
    } else if(semver.compare(this.artifactPublishDetails.newVersion, this.artifactPublishDetails.currentVersion) === -1) { // if new version is less than current version
      this.artifactPublishDetails.isValid = false;
      this.showErrMsg                     = true;
      this.errMsg                         = this.locale.MESSAGE_ERROR_PUBLISH_PREFAB_VERSION;
    } else if (!this.artifactPublishDetails.isNew) {
      this.CheckIfVersionAvailableToPublish();
    }
  }
  setNewVersion($event: any) {
    let version = $event.value || $event;
    if (this.artifactPublishDetails.newVersion != version) {
      this.validateVersion(version);
    }
  }
  unsetNewVersion() {
    this.artifactPublishDetails.newVersion = '';
    this.artifactPublishDetails.isValid = false;
  }
  toggleTooltip() {
    this.tooltipVisible = !this.tooltipVisible;
  }

   // hide semantic version helptext on outside click
  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    if (event.target instanceof HTMLElement) {
      if (!event.target.closest('.wms-help') && !event.target.closest('.wms-clear')) {
        this.tooltipVisible = false;
      }
    }
  }
}
